<script lang="ts" setup>
import type { EventMergeRecord } from '@gmao/shared';
import type { CounterLog } from '@gmao/types';
import { FuncLocation, MachineName } from '@gmao/shared';
import { computed } from 'vue';

const props = defineProps<{
  event: EventMergeRecord;
  events: EventMergeRecord[];
}>();

const log = computed(() => props.event.log as CounterLog);
</script>

<template>
  <div
    flex
    items-center
    gap-1
  >
    <MachineName :name="log.machineName" />
    <FuncLocation :name="log.funcLocationName" />
    <span
      text-lg
      font-bold
    >{{ log.counter }}hrs</span>
  </div>
</template>
